<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{ $tc('models.pickup', 2) }}
        </h1>
      </v-flex>

      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout wrap>
              <v-flex xs12 md4>
                <v-text-field v-model="pickupNumber"
                              append-icon="search"
                              :label="$t('pickupNumber')"
                              @click:append="fetch"
                              clearable
                              @keyup.enter.native="fetch"
                              ></v-text-field>
              </v-flex>

              <v-flex xs12 md4>
                <v-text-field v-model="trackingNumber"
                                append-icon="search"
                                :label="$tc('attrs.tracking_number')"
                                @click:append="fetch"
                                clearable
                                @keyup.enter.native="fetch"
                                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-data-table class="elevation-1"
                      :headers="headers"
                      :items="items"
                      :loading="loading"
                      :total-items="totalItems"
                      :pagination.sync="pagination"
                      item-key="id"
                      :no-data-text="$t('noDataAvailable')">
          <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
          <template v-slot:items="props">
            <tr>
              <td> {{ props.item.user_id }} </td>
              <td> {{ props.item.reference_number }} </td>
              <td> {{ props.item.tracking_number }} </td>
              <td> {{ props.item.carrier }} </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Pickup from '@/client/pickup'

export default {
  name: 'Pickup',

  props: {},

  data () {
    return {
      headers: [
        { text: this.$t('attrs.user_id'), align: 'left', sortable: true, value: 'user_id', width: '5%' },
        { text: this.$t('pickupNumber'), align: 'left', sortable: true, value: 'pickup_number' },
        { text: this.$t('attrs.tracking_number'), align: 'left', sortable: true, value: 'tracking_number' },
        { text: this.$tc('models.carrier', 1), align: 'left', sortable: true, value: 'carrier' },
        // { text: '', align: 'left', sortable: false, value: '' }
      ],
      items: [],
      totalItems: 0,
      pagination: {
        rowsPerPage: 10,
        sortBy: 'created_at',
        descending: true
      },
      loading: false,
      pickupNumber: '',
      trackingNumber: ''
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    async fetch () {
      this.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      let order = ''

      if (sortBy) {
        order = `${sortBy} ${descending ? 'desc' : 'asc'}`
      }

      let where = []
      let include = []

      if (this.pickupNumber) {
          where = [`reference_number = ?`, this.pickupNumber]
      }

      this.items = await Pickup.all({
        page,
        per_page: rowsPerPage,
        where,
        order,
        include: include,
        tracking_number: this.trackingNumber
      })

      this.totalItems = this.items.pagination.total_objects
      this.loading = false
    }
  },

  watch: {
    pagination: {
      handler () {
        this.fetch()
      },
      deep: true
    }
  },

  async mounted () {
    this.fetch()
  }
}
</script>
